import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
// import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { Dialog, DialogTitle, DialogContent, IconButton, Button } from '@material-ui/core';
import { Icon } from '@iconify/react';
import { useTheme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

CampaignRuleDialog.propType = {
  btnName: PropTypes.string,
  ComponentCalled: PropTypes.func,
  dialogTitle: PropTypes.string,
  icon: PropTypes.object,
  editId: PropTypes.object
};

export default function CampaignRuleDialog({ dialogTitle, ComponentCalled, parentRuleId, icon, editId }) {
  const [open, setOpen] = useState(false);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('sm');
  const theme = useTheme();

  const handleClickOpen = () => {
    if (editId) {
      console.log('for edit modal');
      setOpen(true);
    } else {
      console.log('for add modal');
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const stylesSheelt = {
    background: '#eeeeee',
    color: theme.palette.primary.main,
    boxShadow: 'none',
    fontSize: '0.78rem',
    fontWeight: '600',
    minWidth: '55px',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#eeeeee'
    }
  };

  return (
    <>
      {icon ? (
        <IconButton size="small" onClick={() => handleClickOpen()}>
          <Icon icon={icon} />
        </IconButton>
      ) : (
        <Button onClick={() => handleClickOpen()} size="small" variant="contained" sx={stylesSheelt}>
          Edit
        </Button>
      )}
      <Dialog open={open} maxWidth={maxWidth} onClose={handleClose} fullWidth={fullWidth}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent style={{ padding: '24px' }}>
          <ComponentCalled handleClose={handleClose} parentRuleId={parentRuleId} editId={editId} />
        </DialogContent>
      </Dialog>
    </>
  );
}
